export default __webpack_public_path__ + "static/media/purple_space.29bc3f98.jpg";